const styles = (theme: Object) => ({
  root: {
    left: 0,
    backgroundColor: theme.palette.neutrals.background,
    color: theme.palette.neutrals.mainText,
    width: '100%',
    height: 50,
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.neutrals.greyUI}`,
    zIndex: theme.zIndex.toolbar,
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: '0 5%',
  },
  zoomIcons: {
    margin: '0 20px 0 auto',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      margin: '0',
    },
  },
  zoomIcon: {
    padding: 15,
    fontSize: 36,
    color: theme.palette.neutrals.mainText,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  zoomIconDisabled: {
    color: theme.palette.neutrals.greyUI,
  },
  logo: {
    height: '31px',
    width: '111px',
  },
  downloadIcon: {
    marginRight: 11,
    '&:hover': {
      cursor: 'pointer',
    },
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
    },
  },
  loader: {
    color: theme.palette.primary.main,
  },
});

export default styles;
